import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostListComponent } from './post-list/post-list.component';
import { PipeModule } from '../pipes/pipe/pipe.module';
import { PostDetailComponent } from './post-detail/post-detail.component';
import { CreatePost } from './create-post/create-post.component';

const routes: Routes = [
    {
        path: '',
        component: PostListComponent

    },
    {
        path: 'post-detail/:botId/:postId/:isSchedule',
        component: PostDetailComponent
    },
    {
        path: 'create-post/:botId/:postId/:isSchedule',
        component: CreatePost
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes), PipeModule],
    exports: [RouterModule, PipeModule],
  })
export class PostHubRoutingModule {}
